// extracted by mini-css-extract-plugin
export default {"PricingPlans__btn":"style-module__PricingPlans__btn___TANZ8","noncommercial":"style-module__noncommercial___btiiO","active":"style-module__active___VAoek"};